<template>
<div class="content-wrapper">
  <vs-checkbox type="flat" style="padding:2px;" v-model="userCheckboxVal">
    <span style="font-size:12px;">내 Task</span>
  </vs-checkbox>
  <div v-if="windowWidth < 992" style="padding:10px;">
    <!-- <div class="mt-5"> -->
    <vs-tabs alignment="fixed">
      <vs-tab label="할일">
        <!-- <div> -->
        <vx-card class="p-4 text-center scroll-area border border-solid d-theme-border-grey-light rounded relative overflow-hidden shadow bg-white" style="height:580px; shadow:5px;" :is="scrollbarTag">
          <vs-button v-if="activeProjectUserLevel >= 2" class="plus w-full" style="margin-bottom:5px;" color="#6FB4E2" type="border" icon="icon-plus" icon-pack="feather" @click="createTodoItem"></vs-button>
          <Container style="height: 500px;" group-name="1" :get-child-payload="getChildPayload1" @drop="onTodoDrop('todoList', $event)">
            <Draggable v-for="item in todoList" :key="item.id">
              <div class="draggable-item" style=" height:112px;">
                <TaskMainJob :itemValue="item" v-on:remove="taskDelete" @update="updateJob" v-on:selectTask="selectTask" />
              </div>
            </Draggable>
          </Container>
        </vx-card>
        <!-- </div> -->
      </vs-tab>
      <vs-tab label="진행중">
        <!-- <div> -->
        <vx-card class="p-4 text-center scroll-area border border-solid d-theme-border-grey-light rounded relative overflow-hidden shadow bg-white" style="height:580px; shadow:5px;" :is="scrollbarTag">
          <Container style="height: 500px;" group-name="1" :get-child-payload="getChildPayload2" @drop="onInProDrop('inprogressList', $event)">
            <Draggable v-for="item in inprogressList" :key="item.id">
              <div class="draggable-item" style=" height:112px;">
                <TaskMainJob :itemValue="item" v-on:remove="taskDelete" @update="updateJob" v-on:selectTask="selectTask" />
              </div>
            </Draggable>
          </Container>
        </vx-card>
        <!-- </div> -->
      </vs-tab>
      <vs-tab label="완료">
        <!-- <div> -->
        <vx-card class="p-4 text-center scroll-area border border-solid d-theme-border-grey-light rounded relative overflow-hidden shadow bg-white" style="height:580px; shadow:5px;" :is="scrollbarTag">
          <Container style="height: 500px;" group-name="1" :get-child-payload="getChildPayload3" @drop="onDoneDrop('doneList', $event)">
            <Draggable v-for="item in doneList" :key="item.id">
              <div class="draggable-item" style=" height:112px;">
                <TaskMainJob :itemValue="item" v-on:remove="taskDelete" @update="updateJob" v-on:selectTask="selectTask" />
              </div>
            </Draggable>
          </Container>
        </vx-card>
        <!-- </div> -->
      </vs-tab>
    </vs-tabs>
    <!-- </div> -->
  </div>
  <div v-if="windowWidth >= 992">
    <div class="vx-row lg:w-full sm:w-full md:w-full">
      <div class="w-full lg:w-1/3 text-center no-scroll-content" style="padding:10px;">
        <div class="text-center" style="margin:5px; font-size:16px;">
          <p><strong>할일</strong></p>
        </div>
        <vx-card class="p-4 text-center scroll-area border border-solid d-theme-border-grey-light rounded relative overflow-hidden shadow bg-white" style="height:580px; shadow:5px;" :is="scrollbarTag">
          <vs-button v-if="activeProjectUserLevel >= 2" class="plus w-full" style="margin-bottom:5px;" color="#6FB4E2" type="border" icon="icon-plus" icon-pack="feather" @click="createTodoItem"></vs-button>
          <Container style="height: 500px;" group-name="1" :get-child-payload="getChildPayload1" @drop="onTodoDrop('todoList', $event)">
            <Draggable v-for="item in todoList" :key="item.id">
              <div class="draggable-item" style=" height:112px;">
                <TaskMainJob :itemValue="item" v-on:remove="taskDelete" @update="updateJob" v-on:selectTask="selectTask" />
              </div>
            </Draggable>
          </Container>
        </vx-card>
      </div>
      <div class="w-full lg:w-1/3 text-center no-scroll-content" style="padding:10px;">
        <div class="text-center" style="margin:5px; font-size:16px;">
          <p><strong>진행중</strong></p>
        </div>
        <vx-card class="p-4 text-center scroll-area border border-solid d-theme-border-grey-light rounded relative overflow-hidden shadow bg-white" style="height:580px; shadow:5px;" :is="scrollbarTag">
          <Container style="height: 500px;" group-name="1" :get-child-payload="getChildPayload2" @drop="onInProDrop('inprogressList', $event)">
            <Draggable v-for="item in inprogressList" :key="item.id">
              <div class="draggable-item" style=" height:112px;">
                <TaskMainJob :itemValue="item" v-on:remove="taskDelete" @update="updateJob" v-on:selectTask="selectTask" />
              </div>
            </Draggable>
          </Container>
        </vx-card>
      </div>
      <div class="w-full lg:w-1/3 text-center no-scroll-content" style="padding:10px;">
        <div class="text-center" style="margin:5px; font-size:16px;">
          <p><strong>완료</strong></p>
        </div>
        <vx-card class="p-4 text-center scroll-area border border-solid d-theme-border-grey-light rounded relative overflow-hidden shadow bg-white" style="height:580px; shadow:5px;" :is="scrollbarTag">
          <Container style="height: 500px;" group-name="1" :get-child-payload="getChildPayload3" @drop="onDoneDrop('doneList', $event)">
            <Draggable v-for="item in doneList" :key="item.id">
              <div class="draggable-item" style=" height:112px;">
                <TaskMainJob :itemValue="item" v-on:remove="taskDelete" @update="updateJob" v-on:selectTask="selectTask" />
              </div>
            </Draggable>
          </Container>
        </vx-card>
      </div>
    </div>
  </div>
  <vs-prompt @cancel="close" @accept="accept" @close="close" title="Task 생성" accept-text="확인" cancel-text="취소" :active.sync="activePrompt">
    <div class="con-exemple-prompt">
      <vs-input placeholder="내용을 입력해주세요." v-model="taskTitle" class="mb-6 w-full" />
    </div>
  </vs-prompt>
</div>
</template>

<script>
import {
  Container,
  Draggable
} from 'vue-smooth-dnd'
// import draggable from 'vuedraggable'
import TaskMainJob from '@/views/apps/pms/task/TaskMainJob.vue'
// import TaskMainJob from './TaskMainJob.vue'
import TaskMainJobList from '@/views/apps/pms/task/TaskMainJobList.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

// import vSelect from 'vue-select'

export default {
  name: 'TaskMainJobList',
  props: ['propsdata'],
  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    },
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
    activeProjectUserLevel() {
      return this.$store.state.project.ActiveProjectLevel
    },
    windowWidth() {
      return this.$store.state.windowWidth
    },
  },
  data() {
    return {
      dataList: '',
      newItem: '',
      showJob: true,
      todoList: [],
      inprogressList: [],
      doneList: [],
      collectionName: ['', 'todoList', 'inprogressList', 'doneList'],
      ItemCount: 4,
      activePrompt: false,
      taskTitle: '',
      isActive: true,
      deleteInfo: {},
      userCheckboxVal: false,
      previousData: {
        todoList: [],
        inprogressList: [],
        doneList: []
      }
    }
  },
  created() {
    this.$store.dispatch('task/getMyblog', this.$route.params.projectId)
    this.$store.dispatch('task/getTask', Number(this.$route.params.projectId))
      .then(() => {
        var taskList = this.$store.state.task.tasks
        for (var index in taskList) {
          this[this.collectionName[taskList[index].state]].push(taskList[index])
        }
      }).catch(() => {
        this.$vs.notify({
          color: 'danger',
          title: '실패',
          text: '관리자에게 문의 부탁 드립니다.'
        })
        this.$router.push('/apps/space')
      })
  },
  watch: {
    userCheckboxVal() {
      // console.log(this.userCheckboxVal, this.activeUserInfo.uid)
      if (this.userCheckboxVal) {
        this.todoList = this.todoList.filter((task) => task.user_id == this.activeUserInfo.uid)
        this.doneList = this.doneList.filter((task) => task.user_id == this.activeUserInfo.uid)
        this.inprogressList = this.inprogressList.filter((task) => task.user_id == this.activeUserInfo.uid)
      } else {
        this.todoList = []
        this.doneList = []
        this.inprogressList = []
        var taskList = this.$store.state.task.tasks
        for (var index in taskList) {
          this[this.collectionName[taskList[index].state]].push(taskList[index])
        }
      }
    },
    windowWidth() {
      this.setSidebarWidth()
    },
    '$route'() {
      this.todoList = []
      this.inprogressList = []
      this.doneList = []
      this.$store.dispatch('task/getMyblog', this.$route.params.projectId)
      this.$store.dispatch('task/getTask', Number(this.$route.params.projectId))
        .then(() => {
          var taskList = this.$store.state.task.tasks
          for (var index in taskList) {
            this[this.collectionName[taskList[index].state]].push(taskList[index])
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: '실패',
            text: '관리자에게 문의 부탁 드립니다.'
          })
          this.$router.push('/apps/space')
        })
    }
  },
  components: {
    'TaskMainJobList': TaskMainJobList,
    'TaskMainJob': TaskMainJob,
    Container,
    Draggable,
    VuePerfectScrollbar
  },
  methods: {
    setSidebarWidth() {
      if (this.windowWidth < 992) {
        this.isActive = false
      } else {
        this.isActive = true
      }
    },
    updateJob(obj) {
      // console.log(obj)
      var index = this[this.collectionName[obj.oldState]].findIndex((collection) => collection.id == obj.id)
      var itemToAdd = this[this.collectionName[obj.oldState]].splice(index, 1)[0]
      // console.log(index, obj.oldState)
      // console.log(itemToAdd)
      this[this.collectionName[obj.state]].push(itemToAdd)
      // console.log(index, obj.state)
      // if(this[this.collectionName[state]].title != val){
      // }
    },
    close() {
      this.activePrompt = false
    },
    accept() {
      this.$store.dispatch('task/createTask', {
          projectId: Number(this.$route.params.projectId),
          title: this.taskTitle
        })
        .then((resolve) => {
          this.todoList.unshift(resolve)
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: '실패',
            text: '관리자에게 문의 부탁 드립니다.'
          })
        })
    },
    onTodoDrop(collection, dropResult) {
      if (this.activeProjectUserLevel < 2) {
        return
      }
      var preSize = this[collection].length
      // console.log(this.applyDrag(this[collection], dropResult))
      this[collection] = this.applyDrag(this[collection], dropResult)
      // console.log(dropResult)
      if (preSize < this[collection].length) {
        this.$store.dispatch('task/updateTaskState', {
          id: dropResult.payload.id,
          state: 1,
          title: dropResult.payload.title
        })
      }

    },
    onInProDrop(collection, dropResult) {
      if (this.activeProjectUserLevel < 2) {
        return
      }
      var preSize = this[collection].length
      this[collection] = this.applyDrag(this[collection], dropResult)
      if (preSize < this[collection].length) {
        this.$store.dispatch('task/updateTaskState', {
          id: dropResult.payload.id,
          state: 2,
          title: dropResult.payload.title
        })
      }
    },
    onDoneDrop(collection, dropResult) {
      if (this.activeProjectUserLevel < 2) {
        return
      }
      var preSize = this[collection].length
      this[collection] = this.applyDrag(this[collection], dropResult)
      if (preSize < this[collection].length) {
        this.$store.dispatch('task/updateTaskState', {
          id: dropResult.payload.id,
          state: 3,
          title: dropResult.payload.title
        })
      }
    },
    getChildPayload1(index) {
      if (this.activeProjectUserLevel < 2) {
        return
      }
      return this.todoList[index]
    },
    getChildPayload2(index) {
      if (this.activeProjectUserLevel < 2) {
        return
      }
      return this.inprogressList[index]
    },
    getChildPayload3(index) {
      if (this.activeProjectUserLevel < 2) {
        return
      }
      return this.doneList[index]
    },
    createTodoItem() {
      this.activePrompt = true
    },
    outFocus(index) {
      document.getElementById(index).disabled = true
      this.$emit('jobs', document.getElementById(index).value, index)
    },
    enter(index) {
      document.getElementById(index).disabled = true
    },
    clearInput(Item, index) {
      document.getElementById(index).disabled = false
      document.getElementById(index).focus()
    },
    taskDelete(state, id) {
      this.deleteInfo = {
        id: id,
        state: state
      }
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `프로젝트 삭제`,
        text: '선택된 프로젝트를 정말 삭제하시겠습니까?',
        accept: this.acceptDeleteAlert
      })
    },
    acceptDeleteAlert() {
      for (var index in this[this.collectionName[this.deleteInfo.state]]) {
        if (this[this.collectionName[this.deleteInfo.state]][index].id == this.deleteInfo.id) {
          this.$store.dispatch('task/deleteTask', this.deleteInfo.id)
          this[this.collectionName[this.deleteInfo.state]].splice(index, 1)
          return 1
        }
      }
      return 0
    },
    applyDrag(arr, dragResult) {
      const {
        removedIndex,
        addedIndex,
        payload
      } = dragResult
      if (removedIndex === null && addedIndex === null) return arr
      const result = [...arr]
      let itemToAdd = payload
      if (removedIndex !== null) {
        itemToAdd = result.splice(removedIndex, 1)[0]
      }
      if (addedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd)
      }
      return result
    },
    selectTask(val) {
      this.$emit('selectTask', val)
    }
  }
}
</script>

<style lang="css" scoped>
/* @import '../../assets/css/base.css'; */
  .groups {
    display: flex;
    justify-content: stretch;
    margin-top: 10px;
    margin-right: 10px;
  }
  .group {
    margin-left: 10px;
    flex: 1;
  }
  .text {
      font-size: 14px;
      max-width: 400px;
      line-height: 1.5;
  }
</style>
